'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:tower:getUuid');
}

var _invoke = require('../invoke');

/**
 * 获取用户设备信息
 *
 * 目前主要用来获得UUID
 *
 * 支持版本
 * + iTower/0.4+
 *
 * @memberof tower
 * @static
 * @name getUuid
 * @return {Promise<string | err>}
 * @example
 *  hbnb.tower.getUuid()
 *      .then(function(uuid) {
 *          uuid = {
 *              UUID: "xxxxxxxxx"
 *          };
 *      })
 *      .catch(function(err) {
 *          err = {
 *              status: -1
 *          };
 *      });
 */

module.exports = function(cb, eb) {
    return new Promise(function(resolve, reject) {
        _invoke('tower', 'get_uuid', {
            callback: function(result) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('uuid is %j', result, result);
                }
                resolve(result.UUID);
            },
            errback: reject
        });
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/tower/get-uuid.js
// module id = 624
// module chunks = 0